export default {
	activeCard    : '',
	activeContent : {
		title       : 'Title',
		integration : null,
		error       : null,
		message     : null,
	},
	addingIntegration  : false,
	editingIntegration : false,
	featuredProviders  : [],
	integrations       : [],
	isDeleting         : false,
	providers          : [],
	filters            : [],
	search             : '',
	searchResults      : [],
	oauthActive        : false,
}
